export const messagesFirebaseRef = {
    welcomeMessages: '/welcomeMessages/messages',
    returnNotifications: '/notifications/notifications'
}

export const messagesFirebaseRefParent = {
    '/welcomeMessages/messages': '/welcomeMessages',
    '/notifications/notifications': '/notifications'
}